import React from 'react';
import { connect } from 'react-redux';
// Game imports
import { GameGoalFlag } from '../../../../Game/Enums';
// Shared imports
import settings from '../../../../settings';

class LevelGoals extends React.Component {
    getTimeGoalText = (timeGoal) => {
        if(timeGoal < 60) {
            return `${timeGoal} seconden`;
        }

        const min = Math.floor(timeGoal / 60);
        const sec = Math.floor(timeGoal) % 60;
        return `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec} minuten`;
    } 

    getLevelGoals = () => {
        const { levelPopup, gameInfo } = this.props;
        const goals = [];
        let num = 0;

        const addGoal = (goal, imagePath, alt, description) => {
            goals.push((
                <div className="level-goal" key={goal}>
                    <div className="level-goal-icon">
                        <img src={`${settings.assetsPath}${imagePath}`} alt={alt} />
                    </div>
                    <span>{description}</span>
                </div>
            ));
            num += 1;
        }

        if(levelPopup.goals & GameGoalFlag.FINISH) { addGoal(GameGoalFlag.FINISH, "img/icons/finish.png", "Finish", "Haal de finish"); }
        if(levelPopup.goals & GameGoalFlag.POINT_LIMIT) { addGoal(GameGoalFlag.POINT_LIMIT, "img/icons/muntje.png", "Muntje" ,`Haal ${gameInfo.pointsGoal} punten`); }
        if(levelPopup.goals & GameGoalFlag.TIME_LIMIT) { addGoal(GameGoalFlag.TIME_LIMIT, "img/icons/klock.png", "Klok", `Haal het level binnen ${this.getTimeGoalText(gameInfo.timeLimit)}`); }
        if(levelPopup.goals === GameGoalFlag.DIE) { addGoal(GameGoalFlag.DIE, "img/icons/dead.png", "Schedel", "Speel tot je dood gaat"); }

        return {
            elements: goals,
            size: num
        };
    }

    render = () => {
        const goals = this.getLevelGoals();

        return (
            <div className={`level-goals goals-size-${goals.size}`}>
                {goals.elements}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelPopup: state.levelPopup,
    gameInfo: state.gameInfo
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelGoals);